import $ from 'jquery';
import "flexslider";


$(document).ready(function() {
    if( $('.mainslider').length ) {

        $(".flexslider").flexslider({
            animation: "slide", 
            slideshow: true,
            slideshowSpeed: 6000,
            controlNav: true,
            animationLoop: true,
            touch: true,
            pauseOnHover: false,
            pauseOnAction: true,
            controlsContainer: ".flexcontrols"
        });

    }

}); 



